import { render, staticRenderFns } from "./BackendLayout.vue?vue&type=template&id=389c594f&lang=pug"
import script from "./BackendLayout.vue?vue&type=script&lang=js"
export * from "./BackendLayout.vue?vue&type=script&lang=js"
import style0 from "./BackendLayout.vue?vue&type=style&index=0&id=389c594f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports